import React, { useEffect, useRef, useState } from 'react';
import useAuthStore from '../store/useAuthStore';
import location_dark from '../assets/images/location_dark.png';
import { useUserStore } from '../store/useUserStore';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useSendLikeStore } from '../store/useSendLikeStore';
import { useMessageStore } from '../store/useMessageStore';
import { Modal } from "react-bootstrap";
import { useSubscriptionStore } from '../store/useSubscriptionStore';

const WSurl = import.meta.env.VITE_APP_WS_URL;
const MySwal = withReactContent(Swal);

interface ChatProps {
  toUser: number;
  name: string;
  city: string;
  state: string;
  distance: number;
  pic: string;
  show:boolean;
  handleClose: () => void;
}

const Chat: React.FC<ChatProps> = ({ toUser, name, city, state, distance, pic,show, handleClose }) => {
  const { getMessages, userMessages } = useMessageStore();
  const { user } = useUserStore();
  const {sendLike } = useSendLikeStore();
  const { paymentDetails, getSubscription } = useSubscriptionStore();
  const authStore = useAuthStore.getState();
  const userId = authStore.user?.id;

  const [messages, setMessages] = useState<any[]>([]);
  const [isInitialized, setIsInitialized] = useState(false);
  const [message, setMessage] = useState('');
  const [socket, setSocket] = useState<WebSocket | null>(null);
  const [messageCount, setMessageCount] = useState(0);

  const chatRef = useRef<HTMLDivElement | null>(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
    useEffect(() => {
     setMessages([]);
     setIsInitialized(true);
    }, []);

  useEffect(() => {
    const chatBody = chatRef.current;
    if (!chatBody) return;
  
    const handleScroll = async () => {
      if (chatBody.scrollTop === 0 && hasMore) {
        const previousScrollHeight = chatBody.scrollHeight;
        const res = await getMessages(userId, toUser, page + 1);
        if (res.length === 0) setHasMore(false);
  
        setPage((prev) => prev + 1);
  
        // Maintain scroll position after loading more
        setTimeout(() => {
          const newScrollHeight = chatBody.scrollHeight;
          chatBody.scrollTop = newScrollHeight - previousScrollHeight;
        }, 50);
      }
    };
  
    chatBody.addEventListener('scroll', handleScroll);
    return () => chatBody.removeEventListener('scroll', handleScroll);
  }, [page, hasMore, user]);

  // Sync messages with Zustand store
  useEffect(() => {
   
    
    setMessages(userMessages);
    setMessageCount(userMessages?.length);
  }, [userMessages]);

  useEffect(() => {
    if (userId) {
    //  getUserDetails(userId);
      getMessages(userId, toUser,1);
      getSubscription(userId);
    }
  }, [userId, toUser]);

  useEffect(() => {
    if (!userId || !toUser) return;

    const client = new WebSocket(`${WSurl}${toUser}${userId}?type=message`);
    setSocket(client);

    client.onopen = () => console.log('WebSocket connected.');
    client.onclose = () => console.log('WebSocket closed.');
    client.onmessage = (event) => {
      const data = JSON.parse(event.data);

      if (data.type === 'error') {
        showUpgradePlanAlert();
        return;
      }
      setMessages((prev) => [data, ...prev ]);

      // Update Zustand state
      // useMessageStore.setState((state) => ({
      //   userMessages: [...state.userMessages, data],
      // }));
    };

    return () => client.close();
  }, [userId, toUser]);

  const showUpgradePlanAlert = () => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Upgrade Plan</h3>
          <p>
            Upgrade your plan in <a href="/mywallet" className="text-primary">MyWallet</a> to send more messages.
          </p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>
              Close
            </button>
            <a href="/mywallet" className="btn btn-primary">
              Upgrade Now
            </a>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: 'bg-light p-4 rounded',
        closeButton: 'btn-close position-absolute top-0 end-0 m-3',
      },
    });
  };

  const handleSendMessage = () => {
    console.log(messageCount);
    
    if (paymentDetails?.status == 0 && messageCount >= 3) {
      showUpgradePlanAlert();
      return;
    }

    if (!socket || socket.readyState !== WebSocket.OPEN || !message.trim()) {
      return;
    }

    const data = { from: userId, to: toUser, message, message_type: "text" };
    socket.send(JSON.stringify(data));

    // Append to local state
    //setMessages((prev) => [...prev, data]);

    // Update Zustand store
    // useMessageStore.setState((state) => ({
    //   userMessages: [...state.userMessages, data],
    // }));

    setMessage('');
    if(messageCount==0){
      sendLike(toUser, 50, '','')
    }

    if (paymentDetails?.status == 0) {
      setMessageCount((prev) => prev + 1);
    }
  };





  return (
    
<Modal className="offcanvas offcanvas-end bg-light" id="datingprofileChat"  show={show} >
    
      <div className="offcanvas-header">
      <div className="dp_user_chat_header">
                <div className="d-flex mb-3 align-items-center">
                    <img src={pic} alt="" className="dp_user_img me-3" />
                    <div>
                    <h5 className="mb-0 font18">{name}</h5>
                    <p className="mb-0">
                      <img src={location_dark} className="me-2" alt="Location" /> {city} {state}, {distance.toFixed(1)} miles away
                    </p>
                    </div>
                </div>
                <button type="button" onClick={handleClose} className="btn-close ms-auto" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
       
      </div>

      <div className="offcanvas-body chat-messages" ref={chatRef}>
        {!isInitialized || !messages || messages.length === 0 ? (
          <div className="text-center">
            <h3>
              <i className="fa-regular fa-comment-dots text-primary"></i> Ready to chat?
            </h3>
            <p>Start the conversation for free, then wait for their response. You’ve got this!</p>
          </div>
        ) : (
          <div className="dp_message_box_lists_main">
                        {[...messages]?.reverse().map((msg, index) => (
                        <div key={index} className="dp_message_box_lists mb-2">
                            <span className="dp_message_box_profile">
                            {msg.from == userId ? 'You' :  `${user.first_name.charAt(0)}`}
                            </span>
                            <div className="dp_message_box_lists_profile">
                            {msg.message}
                            </div>
                        </div>
                        ))}
                    </div>
        
        )}
      </div>

      <div className="offcanvas-footer chatbox_bottom">
        <div className="form-group d-flex">
          <input
            type="text"
            className="form-control"
            placeholder="Start the conversation..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault(); // Prevents default form submit behavior
                handleSendMessage();
              }
            }}
          />
          <button className="btn" onClick={handleSendMessage}>
            <i className="fa-solid fa-paper-plane"></i>
          </button>
        </div>
      </div>
   
    </Modal>
 
  );
};

export default Chat;
